import React from "react";
import { useNavigate } from "react-router-dom";

const LogoutButton = () => {
  const navigate = useNavigate();

  const logout = (event) => {
    event.stopPropagation();
    // console.log("Logging out...");
    localStorage.removeItem("auth");
    localStorage.removeItem("portal");
    navigate("/");
    // console.log("Redirecting to home...");
  };

  return (
    <button onClick={logout} className="text-red-500">
      Log Out
    </button>
  );
};

export default LogoutButton;
